import { dispatchError, dispatchLoading, dispatchSuccess } from '../utils';
import { GET_DESTINASI, API_TIMEOUT } from '../utils/constant';

import axios from 'axios';

export const GET_LIST_DESTINASI = 'GET_LIST_DESTINASI';

export const getDestinasi = () => {
  return (dispatch) => {
    dispatchLoading(dispatch, GET_LIST_DESTINASI);

    axios({
      method: 'get',
      url: GET_DESTINASI,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          dispatchError(dispatch, GET_LIST_DESTINASI, 'error');
        } else {
          //BERHASIL

          dispatchSuccess(
            dispatch,
            GET_LIST_DESTINASI,
            response.data.data ? response.data.data : []
          );
        }
      })
      .catch((error) => {
        // ERROR
        dispatchError(dispatch, GET_LIST_DESTINASI, error);
        alert(error);
      });
  };
};
